import React, { memo } from 'react'

import { Button, Modal, Icon } from '../index'
import { util } from '../../../util'
import Proptypes from 'prop-types'

export const RuleCompleteModal = ({ show, title, close, description, btnText = 'CLOSE' }) => {
    if (!show) {
        return null
    }

    const header = (
        <div className={'rule-complete__header'}>
            <Icon
                size={'lg'}
                color={'success'}
                display={'inline'}
                renderIcon={util.CheckCircleIcon}
            />
            <p className={'rule-complete__header--title'}>{title}</p>
        </div>
    )

    const content = (
        <div className={'rule-complete__content mb-5'}>
            <p className={'rule-complete__content--description'}>{description}</p>
        </div>
    )

    const actions = (
        <div className={'rule-complete__action'}>
            <Button
                color={'primary'}
                size={'md'}
                className={'rule-complete__action--close'}
                onClick={close}
            >
                {btnText}
            </Button>
        </div>
    )

    return <Modal header={header} content={content} actions={actions} className={'rule_complete'} />
}

RuleCompleteModal.propTypes = {
    /* * @param show {Boolean} -> true will display the complete modal. */
    show: Proptypes.bool,

    /* * @param title {String} -> modal title */
    title: Proptypes.string,

    /* * @param close {callback} -> Callback function to close Modal */
    close: Proptypes.func,

    /* * @param description {String} -> modal description */
    description: Proptypes.string,
}

export default memo(RuleCompleteModal)
